import { ENTITY, ENTITY_TO_PATH_MAP } from './entity';

export const CONVERSION_ROUTE = `/${ENTITY_TO_PATH_MAP[ENTITY.CONVERSION]}`;
export const CONVERSION_ID_PARAM_NAME = 'conversionId';
export const CONVERSION_ID_PARAM_TEMPLATE = `/:${CONVERSION_ID_PARAM_NAME}?`;
